<template>
	<el-row class="container">
		<el-col :span="24" class="header">
			<el-col :span="21" class="logo logo-width">
				<router-link to="/"> {{ sysName }} <small style="font-size: 12px">Sales workbench</small> </router-link>
			</el-col>
			<el-col :span="1.5" class="userinfo">
				<el-dropdown trigger="hover">
					<span class="el-dropdown-link userinfo-inner">
						<img :src="avatarUrl()" @error="onAvatarError" />
						{{ $store.state.user.userName }}
					</span>
					<el-dropdown-menu slot="dropdown" bottom>
						<el-dropdown-item @click.native="customerSetting">{{ $t("index.customerSettings") }}</el-dropdown-item>
						<el-dropdown-item @click.native="personalInfo">{{ $t("index.personalInformation") }}</el-dropdown-item>
						<el-dropdown-item divided @click.native="logout">{{ $t("index.logOut") }}</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</el-col>
			<div class="language">
				<el-dropdown>
					<span class="el-dropdown-link">{{ $t("index.selectLanguage") }}<i class="el-icon-arrow-down el-icon--right"></i> </span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item @click.native="changeLanguage('zh')">中文繁體</el-dropdown-item>
						<el-dropdown-item @click.native="changeLanguage('en')">English</el-dropdown-item>
						<el-dropdown-item @click.native="changeLanguage('es')">Spanish</el-dropdown-item>
						<el-dropdown-item @click.native="changeLanguage('th')">Thai</el-dropdown-item>
						<el-dropdown-item @click.native="changeLanguage('vi')">Vietnamese</el-dropdown-item>
						<el-dropdown-item @click.native="changeLanguage('fi')">Filipino</el-dropdown-item>
						<el-dropdown-item @click.native="changeLanguage('hi')">Hindi</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
		</el-col>
		<el-col :span="24" class="main">
			<aside class="menu-expanded">
				<!--导航菜单-->
				<el-menu
					:default-active="$route.path"
					class="el-menu-vertical-demo"
					unique-opened
					router
					background-color="#545c64"
					text-color="#fff"
					active-text-color="#ffd04b"
				>
					<template v-for="(item, index) in $router.options.routes">
						<template v-if="!item.hidden">
							<el-submenu :index="index + ''" v-if="!item.leaf" v-bind:key="index">
								<template slot="title"><i :class="item.iconCls"></i> {{ $t(`router.${item.name}`) }}</template>
								<template v-for="child in item.children">
									<el-menu-item :index="child.path" :key="child.path" v-if="!child.hidden" @click="onMenuItemClick(child.path)">
										{{ $t(`router.${child.name}`) }}
										<!-- 在服务维护菜单项旁边添加红点 -->
										<el-badge
											v-if="child.path == '/setting/service-maintenance' && serviceProviderUnreadStatus === 0"
											is-dot
											style="margin-left: 5px; margin-top: -4px"
										></el-badge>
									</el-menu-item>
								</template>
							</el-submenu>
							<el-menu-item v-if="item.leaf && item.children.length > 0" :index="item.children[0].path" v-bind:key="index">
								<i :class="item.iconCls"></i>
								{{ $t(`router.${item.children[0].name}`) }}
								<el-badge
									v-if="item.children[0].path == '/chat' && $store.state.chat.totalUnread > 0"
									is-dot
									style="margin-left: 5px; margin-top: -4px"
								></el-badge>
							</el-menu-item>
						</template>
					</template>
					<el-menu-item-group class="version-warp">
						<template slot="title">version: {{ versionNumber }}</template>
					</el-menu-item-group>
				</el-menu>
			</aside>
			<section class="content-container">
				<div class="grid-content bg-purple-light">
					<el-col :span="24" class="breadcrumb-container">
						<span class="title">{{ $t(`router.${$route.name}`) }} {{ $route.params.id ? $route.params.id : "" | removeFrontZero }}</span>
						<el-button size="mini" v-if="isBack" class="back" @click="handleBack">{{ $t("chatHistory.back") }}</el-button>
					</el-col>
					<el-col :span="24" class="content-wrapper">
						<transition name="fade" mode="out-in">
							<router-view @updateServiceProviderUnreadStatus="updateServiceProviderUnreadStatus"></router-view>
						</transition>
					</el-col>
				</div>
			</section>
		</el-col>
	</el-row>
</template>

<script>
import { getImToken } from "@/utils/cookies";
import { wsUrl, version } from "@/config/env";
import { getServiceProviderReadStatus } from "@/services/api-v2/api-v2";

export default {
	name: "index",

	created: function () {
		if (!this.$store.state.user.isLogin) {
			// 初始化用户消息
			this.$store.dispatch("getStaffInfo");

			// 获取未读消息数量
			this.$store.dispatch("getTotalUnread");

			// 连接websocket服务
			this.$connect(wsUrl + "?token=" + getImToken());
		}

		// 加载服务商列表未读状态
		this.loadServiceProviderUnreadStatus();
	},

	watch: {
		// 监听路由变化，如果进入服务维护页面则重新加载未读状态
		$route(to, from) {
			if (to.path.startsWith("/setting/service-maintenance") && !from.path.startsWith("/setting/service-maintenance")) {
				this.loadServiceProviderUnreadStatus();
			}
		},
	},

	data() {
		return {
			sysName: "OMELink",
			versionNumber: version,
			serviceProviderUnreadStatus: 1, // 默认为已读
		};
	},

	methods: {
		//退出登录
		logout: function () {
			var _this = this;
			this.$confirm(this.$t("index.confirmExit"), this.$t("index.hint"), {
				type: "warning",
				cancelButtonText: this.$t("common.cancel"),
				confirmButtonText: this.$t("common.confirm"),
			})
				.then(() => {
					this.$disconnect(); // 断开websocket连接
					this.$store.dispatch("logout");
					this.$router.push({ path: "/login" });
				})
				.catch(() => {});
		},

		// 跳转到个人资料页面
		personalInfo: function () {
			this.$router.push({ path: "/setting/personal" });
		},

		// 跳转到客户设置
		customerSetting: function () {
			this.$router.push({ path: "/setting/customer" });
		},

		// 头像地址：统一使用后端签名地址，缺失时显示默认头像
		avatarUrl() {
			return this.$store.state.user.avatarUrl || require("@/assets/default_avatar.jpg");
		},

		onAvatarError(event) {
			event.target.src = require("@/assets/default_avatar.jpg");
		},

		handleBack() {
			switch (this.$route.name) {
				case "productSettings":
					this.$router.push({ path: "/setting/customer" });
					break;
				case "syncSettings":
					this.$router.push({ path: `/setting/customer-product/${this.$route.params.id}` });
					break;
				case "customerBinding":
					this.$router.push({ path: "/setting/customer" });
					break;
				case "omelinkUserServiceMaintenance":
					if (this.$route.params.id) {
						this.$router.push({ path: "/setting/service-maintenance" });
					}
					break;
			}
		},
		changeLanguage(lang) {
			this.$i18n.locale = lang;
		},

		// 加载服务商列表未读状态
		async loadServiceProviderUnreadStatus() {
			try {
				const response = await getServiceProviderReadStatus();
				if (response && response.data) {
					this.serviceProviderUnreadStatus = response.data.has_read;
				}
			} catch (error) {
				console.error("Failed to load service provider unread status:", error);
			}
		},

		// 更新服务商未读状态 (供服务商列表子组件调用)
		updateServiceProviderUnreadStatus(status) {
			this.serviceProviderUnreadStatus = status;
		},

		onMenuItemClick(path) {
			// 如果点击的是服务维护页面，但当前就在该页面，则不执行任何操作
			if (path === "/setting/service-maintenance" && this.$route.path === path) {
				return;
			}

			// 否则正常导航
			this.$router.push({ path });
		},
	},

	computed: {
		isBack() {
			switch (this.$route.name) {
				case "productSettings":
					return true;
				case "syncSettings":
					return true;
				case "customerBinding":
					return true;
				case "omelinkUserServiceMaintenance":
					return !!this.$route.params.id;
				default:
					return false;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.router-link-active {
	text-decoration: none;
	font-size: 22px;
	color: #fff;
}
.container {
	position: absolute;
	top: 0px;
	bottom: 0px;
	width: 100%;
	left: 0px;

	.header {
		height: 60px;
		line-height: 60px;
		background: #1778bf;
		color: #fff;

		.language {
			text-align: right;
			margin-right: 15px;
			float: right;
			cursor: pointer;
			.el-dropdown-link {
				color: #fff;
			}
		}
		.userinfo {
			text-align: right;
			padding-right: 35px;
			float: right;

			.userinfo-inner {
				cursor: pointer;
				color: #fff;

				img {
					width: 40px;
					height: 40px;
					border-radius: 20px;
					margin: 10px 0px 10px 10px;
					float: right;
				}
			}
		}

		.logo {
			height: 60px;
			font-size: 22px;
			padding-left: 20px;
			padding-right: 20px;
			border-color: rgba(238, 241, 146, 0.3);

			img {
				width: 40px;
				float: left;
				margin: 10px 10px 10px 18px;
			}

			.txt {
				color: #fff;
			}
		}

		.logo-width {
			width: 230px;
		}

		.tools {
			padding: 0px 23px;
			width: 14px;
			height: 60px;
			line-height: 60px;
			cursor: pointer;
		}
	}

	.main {
		display: flex;
		position: absolute;
		top: 60px;
		bottom: 0px;
		overflow: hidden;

		aside {
			flex: 0 0 230px;
			width: 230px;
			.el-menu {
				height: 100%;
			}
		}

		.menu-expanded {
			flex: 0 0 230px;
			width: 270px;
		}

		.content-container {
			flex: 1;
			overflow-y: scroll;
			padding: 20px;

			.breadcrumb-container {
				.title {
					float: left;
					font-weight: 600;
					color: rgba(0, 0, 0, 0.85);
					font-size: 20px;
				}
				.back {
					float: right;
				}

				.breadcrumb-inner {
					float: right;
				}
			}

			.content-wrapper {
				background-color: #fff;
				box-sizing: border-box;
				padding-top: 20px;
			}
		}
	}

	.version-warp {
		position: absolute;
		left: 0;
		bottom: 0;
	}
}

:deep {
	.el-breadcrumb__item {
		.el-breadcrumb__inner {
			color: rgba(0, 0, 0, 0.45);
			font-weight: 500;

			&:last-child {
				color: rgba(0, 0, 0, 0.85);
			}
		}
	}
	// 允许菜单项文本换行
	.el-menu-item {
		white-space: normal;
		line-height: 1.5;
		height: auto;
		min-height: 56px;
		display: flex;
		align-items: center;
	}
}
</style>
